import { faBell } from '@fortawesome/pro-regular-svg-icons/faBell';
import React from 'react';
import { handleClick } from './helper';
import NavLink from './NavLink';
import * as styles from './styles.module.scss';

const Requested = ({
  copy,
  dataLinkId,
  isActive,
  setActive,
}: {
  copy: string;
  dataLinkId: string;
  isActive?: boolean;
  setActive?: (ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}) => {
  const iconContainerWaived = `${styles.LeftNavIconLinkContainer} ${styles.IconLinkContainer}`;
  const RequestedLink: string = `${styles.LinkRight}  ${styles.Requested} ${
    isActive ? styles.Active : ''
  }`;

  const RequetsedIconClass = `${styles.Icon} ${styles.Requested} ${
    isActive ? styles.Active : ''
  }`;

  const onClick = (ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    handleClick(ev, setActive);
  };

  return (
    <NavLink
      dataLinkId={dataLinkId}
      icon={faBell}
      iconClassName={RequetsedIconClass}
      iconContainerClassName={iconContainerWaived}
      textClassName={RequestedLink}
      copy={copy}
      onClick={onClick}
    />
  );
};

export default Requested;
